import NumericInput from './NumericInput'
import { DIMENSIONS } from './utils'
export default NumericInput
export {
    DIMENSIONS
}